import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { WizardModel } from '../models/wizard-model';
import { UserActionsLoggingManager } from '@user/service/logging/user-actions-logging.manager';

@Injectable({ providedIn: 'root' })
export class ConfigurationWizardService {

  private _finishedCreation = new Subject<void>();

  private _currentWizard = new BehaviorSubject<WizardModel | null>(null);

  constructor(
    private userActionsLoggingManager: UserActionsLoggingManager,
  ) {}

  public submitEnabled = true;

  public get currentWizard$(): Observable<WizardModel | null> {
    return this._currentWizard.asObservable();
  }

  public get currentWizard() {
    return this._currentWizard.value;
  }

  public get finishedCreation$(): Observable<void> {
    return this._finishedCreation;
  }

  public start(wizardModel: WizardModel): void {
    this.userActionsLoggingManager.logFunction('configuration-creation-wizard.start-creation.' + wizardModel.type);
    this.reset();
    this._currentWizard.next(wizardModel);
  }

  public reset(): void {
    this.submitEnabled = true;
    this._currentWizard.next(null);
  }

  public async nextStep(): Promise<void> {
    if (!this.currentWizard) {
      return;
    }

    if (this.currentWizard.currentStepIndex + 1 === this.currentWizard.numberOfSteps) {
      await this.currentWizard.create();
      this._finishedCreation.next();
      this.userActionsLoggingManager.logFunction('configuration-creation-wizard.finish-creation.' + this.currentWizard.type);
    } else {
      await this.currentWizard.nextStep();
    }
  }

  public async previousStep(): Promise<void> {
    if (!this.currentWizard) {
      return;
    }

    await this.currentWizard.previousStep();
  }
}
